
import * as crypto from 'crypto';
import * as constants from 'constants';

/**
cifrado
1 - Generar clave AES( 256 bits ) junto con vector de inicializacion IV
2 - Cifrar xml con datos biometricos(biometry_raw.xml) con clave AES(CBC / pkcs7 padding y tama�o de bloques 128)
3 - Coger clave publica del certificado(ej PF_ACTIVO_EIDAS.crt)
4 - Cifrar(RSA / padding PKCS1)   con la clave p�blica  del certificado la clave aes
5 - Escribir en un stream(byte[]): longitud de la clave aes cifrada(paso 4), longitud IV, clave aes cifrada(paso 4), IV, xml biometrico cifrado(paso 2)

descifrado
1 - extraer longitud de la clave cifrada (4 bytes )
2 - extraer longitud de IV (4 bytes )
3 - convertir longitudes a int 
4 - extraer clave cifrada
5 - extraer IV
6 - extraer datos biometricos cifrados (datos totales -  (lengthK + lengthIV + 8))
6 - recuperar clave privada del certificado 
7 - descifrar clave aes
8 - descifrar datos biometricos (paso 6) con clave aes (paso 7)
 */

/**
 * Funcion para generar una cadena cifrada según los parametros que se le pasa.
 * @param {string} text  Cadena con el XML para cifrar.
 * @param {string} publicKey  Cadena con la clave pública para cifrar la llave AES.
 * @returns {string} Cadena cifrada en base64.
 */
const generate = (text: string, publicKey: string): string => {
  // Generar clave AES( 256 bits )
  const key: string = getAESkey();
  // Definir length de IV que generaremos en unas lineas
  const IV_LENGTH: number = 16;
  const algorithm: string = 'aes-256-cbc';
  // Generar IV (vector de inicialización) pasandole length
  const iv: Buffer = crypto.randomBytes(IV_LENGTH);

  // Cifrar xml con datos biométricos
  const xml: string = encrypt(text, key, iv, algorithm);

  /**
   * Encriptar la clave AES con la clave pública del certificado
   */
  const keyEncrypted: Buffer = crypto.publicEncrypt({
    key: publicKey,
    padding: constants.RSA_PKCS1_PADDING
  }, Buffer.from(key, 'hex'));

  // Length de la clave  AES encriptada - el valor está representado en un array of 32-bit unsigned integers
  const l: Uint32Array = new Uint32Array([keyEncrypted.length]);
  // Length de IV generado - (see above)
  const l2: Uint32Array = new Uint32Array([IV_LENGTH]);

  // Generar buffer de variable l y l2 (accediendo propiedad .buffer de Uint32Array)
  const a: Buffer = Buffer.from(l.buffer); // contiene length de la clave AES encriptada
  const b: Buffer = Buffer.from(l2.buffer); // contiene length de IV.

  /**
   *  Concatena 5 buffers - Length de la clave AES cifrada (primeros 4 bytes), length IV (segundos 4 bytes), clave AES cifrada, IV, XML cifrado
   */
  const result: Buffer = Buffer.concat([Buffer.from(a.buffer), Buffer.from(b.buffer), Buffer.from(keyEncrypted), iv, Buffer.from(xml, 'hex')]);

  return result.toString('base64');
};

/**
 * Funcion para cifrar el XML.
 * @param {string} text XML content as a string
 * @param {string} key AES key generated
 * @param {Buffer} iv Initialization vector used in the encryption
 * @param {string} algorithm Initialization vector used in the encryption
 * @returns {string} Cadena con la clave AES en hex.
 */
const encrypt = (text: string, key: string, iv: Buffer, algorithm: string): string => {
  const cipher = crypto.createCipheriv(algorithm, Buffer.from(key, 'hex'), iv);
  // @ts-ignore CHECK THE ERROR
  let encrypted = cipher.update(text);
  encrypted = Buffer.concat([encrypted, cipher.final()]);
  return encrypted.toString('hex');
};

/**
 * Funcion que genera la clave AES (256bit).
 * @returns {string} Cadena con la clave AES en hex.
 */
const getAESkey = (): string => {
  // Tenemos que convertir bits a bytes - por eso / 8
  return crypto.randomBytes(256 / 8).toString('hex');
};

export {
  generate
};
